import { Box } from 'components/elements'
import { styled } from 'styles'
export const Root = styled(Box, {
  backgroundColor: '$white',
  height: 'auto',
  color: '$black',
  fontFamily: '$inter',
  fontStyle: 'normal',
  mx: '$5',
  maxWidth: '1200px',
})
export const ContentWrapper = styled(Box, {
  'mx': '$7',
  'mt': '$6',
  'textAlign': 'center',
  'lineHeight': '150%',
  '& .mainContent': {
    textTransform: 'uppercase',
    letterSpacing: '0.04rem',
    color: '$gray1',
  },
  '& .important': {
    letterSpacing: '0.01rem',
    color: '$black00',
  },
  '& .certificateTextLine1': {
    color: '$black00',
    textAlign: 'left',
    // maxWidth: '980px',
    // margin: '0 auto',
    lineHeight: '140%',
    letterSpacing: '0.01rem',
    mb: '$2 !important',
    fontWeight: '$semibold',
  },
  '& .certificateTextLine2': {
    color: '$black00',
    textAlign: 'center',
    // maxWidth: '980px',
    // margin: '0 auto',
    lineHeight: '140%',
    letterSpacing: '0.01rem',
    mb: '$2 !important',
    fontWeight: '$semibold',
  },
  '& .certificateSubText': {
    color: '$black00',
    textAlign: 'center',
    maxWidth: '980px',
    margin: '10px auto 0',
    lineHeight: '140%',
    letterSpacing: '0.01rem',
    mb: '$2 !important',
    fontWeight: '$semibold',
  },
  '& .certificateNote': {
    color: '$black00',
    textAlign: 'center',
    maxWidth: '980px',
    margin: '10px auto 0',
    lineHeight: '140%',
    letterSpacing: '0.01rem',
    fontWeight: '$semibold',
  },
  '& .contentAfterTable': {
    textAlign: 'left',
    width: 'auto',
  },
})
export const StyledCell = styled('td', {
  textAlign: 'left',
  padding: '10px 20px',
})
export const logo = {
  width: '15rem',
  mt: '30px',
  color: '$black',
  textAlign: 'center',
}
export const Heading = styled(Box, {
  'mt': '$8',
  'lineHeight': '150%',
  'textAlign': 'center',

  '& > .mainHeading': {
    textAlign: 'center',
    textTransform: 'uppercase',
  },
})
export const Row = styled(Box, {
  display: 'grid',
  gridTemplateColumns: '1fr 3fr',
})
export const Footer = styled(Box, {
  '& .heading': {
    display: 'flex',
    justifyContent: 'center',
    fontWeight: '$semibold',
    mt: '$8',
  },
  '& .content': {
    textAlign: 'center',
    mx: '$7',
    pb: '$7',
  },
})
export const TableStyle = {
  mt: '$6',
  mx: '$7',
  border: '1px solid #gray12',
  width: '1100px',
  maxWidth: '1200px',
  borderRadius: '$sm',
  tableLayout: 'fixed',
}
export const RowStyle = {
  borderBottom: '1px solid #gray12',
  verticalAlign: 'top',
}
export const InlineTextCss = {
  display: 'flex',
  columnGap: 10,
}
